'use strict';

import {addSelectedCompanyHandler, companyGuard, getSelectedCompany} from "../jquery-functions-library";
import { element_exists } from "../functions";

export var fnPowerBI = function () {

    if (!element_exists('.power_bi')) {
        return false;
    }

    addSelectedCompanyHandler(getPowerBI);

    getPowerBI();
}

function getPowerBI() {

    var selectedCompanyId;

    if ($('body').attr('data-company') !== undefined) {
        selectedCompanyId = $('body').attr('data-company');
    }
    else if ($(this).attr('value') !== undefined) {
        selectedCompanyId = $(this).attr('value');
        $('#selected_company').val(selectedCompanyId);
    }
    else {
        selectedCompanyId = getSelectedCompany();
    }

    if (!companyGuard()) {
        $('.choose_company').hide();
        $.ajax({
            type: 'GET',
            data: {
                company_id: selectedCompanyId
            },
            url: '/getPowerBI',
            success: function (response) {
                $('#reportContainer').show();
                var embedConfiguration = {
                    type: 'report',
                    tokenType: 1, // 0 = Aad, 1 = Embed
                    accessToken: response.token,
                    id: response.report_id,
                    embedUrl: 'https://app.powerbi.com/reportEmbed?reportId=' + response.report_id + '&groupId=' + response.group_id
                };
                var $reportContainer = $('#reportContainer');
                var report = powerbi.embed($reportContainer.get(0), embedConfiguration);
                report.on('error', function(event)
                {
                    if(event.detail.errorCode == '401'){
                        $('#reportContainer').hide();
                        window.location.reload();
                    }
                });

            },
            error: function (data) {
                $('#reportContainer').hide();
                toastr.error(data.responseJSON.error);
            }
        });
    }
    else if (selectedCompanyId == 'default') {
        $('#reportContainer').hide();
    }
}
